import React from 'react';
import { Typography, Flex } from '@duxton-web/ui';
import { CopyOutlined } from '@duxton-web/icons';
import {
  colorBaseNeutral500,
  colorBaseNeutral900,
  colorContentPlaceholder,
  colorStatusNeutralDefault,
} from '@duxton-web/design-tokens/themes/light';

const DataBox = ({
  label,
  content,
  enableContentCopy = false,
  isContentEmpty = false,
  width = '50%',
}) => {
  const copyable = enableContentCopy
    ? {
      icon: (
        <CopyOutlined
          style={{ fontSize: 20, color: colorStatusNeutralDefault }}
        />
      ),
    }
    : false;

  return (
    <Flex vertical gap={8} style={{ width }}>
      <Typography.Body level={3} style={{ color: colorBaseNeutral500 }}>
        {label}
      </Typography.Body>
      <Flex align="center" gap={4}>
        <Typography.Body
          level={2}
          copyable={copyable}
          italic={isContentEmpty}
          style={{
            color: isContentEmpty
              ? colorContentPlaceholder
              : colorBaseNeutral900,
          }}
        >
          {content || '-'}
        </Typography.Body>
      </Flex>
    </Flex>
  );
};

export default DataBox;
